const state = {
  query: '',
};

const useGooglePlaces = ({ container }) => {
  const init = ({ helper }) => {
    const options = {
      types: ['(regions)'],
      fields: ['geometry'],
    };

    const autocomplete = new google.maps.places.Autocomplete(container, options);

    autocomplete.addListener('place_changed', function (e) {
      const place = autocomplete.getPlace();
      const location = place.geometry.location;
      const lat = location.lat();
      const lng = location.lng();

      state.query = container.value;

      helper
        .setQueryParameter('insideBoundingBox', undefined)
        .setQueryParameter('aroundLatLngViaIP', false)
        .setQueryParameter('aroundLatLng', `${lat},${lng}`)
        .search();
    });

    container.addEventListener('keydown', function (event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        return;
      }
    });
  };

  const getWidgetUiState = (uiState, { searchParameters }) => {
    const position = searchParameters.aroundLatLng;

    if (position && !state.query) {
      const { googlePlaces, ...uiStateWithoutPlaces } = uiState;

      return uiStateWithoutPlaces;
    }

    return {
      ...uiState,
      googlePlaces: {
        query: state.query,
        position,
      },
    };
  };

  const getWidgetSearchParameters = (searchParameters, { uiState }) => {
    const { query = '', position } = uiState.googlePlaces || {};
    console.log(uiState);

    state.query = query;

    container.value = query;

    return searchParameters
      .setQueryParameter('insideBoundingBox', undefined)
      .setQueryParameter('aroundLatLngViaIP', false)
      .setQueryParameter('aroundLatLng', position || undefined);
  };

  return {
    init,
    getWidgetUiState,
    getWidgetSearchParameters,
  };
};

export const googlePlacesWidget = (widgetOptions) => useGooglePlaces(widgetOptions);
